<app-web-loader *ngIf="isLoader"></app-web-loader>
<div class="modal fade PropertyDetailsModel" id="PropertyDetailsModel" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body" *ngIf="PropertyInfo != null">

                <div class="row mrg0A" id="property-info-{{PropertyInfo?.RequestID}}">
                    <div class="col-sm-5 back_txt" (click)="closeModel()"><i class="backto_icon"></i> Click to Back
                    </div>
                    <div class="clear mrg10B"></div>
                    <div class="col-sm-9">
                        <div class="Property_Title">{{ PropertyInfo?.Property_Title }}</div>
                        <div class="area_txt">
                            <img src="assets/images/property/location.png" />
                            {{ PropertyInfo?.Address }}
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <ul class="leftli right">
                            <li>
                                <button type="button" title="Download" (click)="captureAndDownload(PropertyInfo)">
                                    <img src="assets/images/property/download_app.png">
                                </button>
                            </li>
                            <li>
                                <button title="Report fraud" (click)="share(PropertyInfo)">
                                    <img src="assets/images/property/share_icon.png">
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="box_br mt-3">
                    <div class="row mrg0A" *ngIf="propertyImagesList?.length > 0">
                        <div class="col-md-6 pad5A relative">
                            <img [src]="viewBaseImg" class="property_img_lrg" (click)="openImagePreview(viewBaseImg)"
                                style="cursor: zoom-in;" />
                        </div>

                        <!-- Image Preview Modal -->
                        <div class="modal fade" id="imagePreviewModal" tabindex="-1" role="dialog"
                            aria-labelledby="imagePreviewModalLabel" aria-hidden="true" style="padding-right: 0 !important;">
                            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                                <div class="modal-content">
                                    <div class="modal-body position-relative p-0" style="text-align:center; background:#000;">
                                        <button type="button" class="close close_div text-white position-absolute top-0 end-0 m-3" (click)="closeImagePreview()"
                                            aria-label="Close" style="z-index:20;">
                                            <span aria-hidden="true">&times;</span>
                                        </button>

                                        <!-- Prev/Next Controls -->
                                        <button class="btn btn-link text-white position-absolute start-0 top-50 translate-middle-y ms-2 prev-btn" (click)="prevImage()" style="z-index:20;">
                                            <i class="fas fa-chevron-left fa-2x"></i>
                                        </button>
                                        <button class="btn btn-link text-white position-absolute end-0 top-50 translate-middle-y me-2 next-btn" (click)="nextImage()" style="z-index:20;">
                                            <i class="fas fa-chevron-right fa-2x"></i>
                                        </button>

                                        <img [src]="previewImgSrc" alt="Preview"
                                            style="width:100%; max-height:90vh; object-fit:contain; background:#000;" />

                                        <div class="image-counter position-absolute bottom-0 start-50 translate-middle-x mb-2 text-white" style="z-index:20; margin:15px; background: rgba(0,0,0,0.4); padding:6px 10px; border-radius:20px;">
                                            {{ current + 1 }} / {{ propertyImagesList.length }}
                                        </div>

                                        <!-- Thumbnail strip inside modal -->
                                        <div class="modal-thumb-strip d-flex justify-content-center gap-2 p-2 bg-dark" style="overflow:auto;">
                                            <img *ngFor="let img of propertyImagesList; let i = index" [src]="img" (click)="goToImage(i)"
                                                [class.active]="i === current" style="width:80px; height:60px; object-fit:cover; cursor:pointer; border-radius:6px; opacity:0.8;" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row img_div_scroll">
                                <div *ngFor="let pImgs of propertyImagesList; let i = index" class="col-sm-6 pad5A">
                                    <img (click)="openImagePreview(pImgs, i)" [src]="pImgs" class="property_img_sml" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="clear mb-3"></div>
            <div class="row mrg0A">
                <div class="col-md-8">
                    <div class="row mrg0A">
                        <div class="col-sm-6" align="center">
                            <div class="hd_txt">{{ PropertyInfo?.Budget }}</div>
                        </div>
                        <div class="col-sm-6" align="center">
                            <ul class="leftli">
                                <li *ngIf="PropertyInfo?.Bed_Rooms > 0">
                                    <div class="hd_txt"> {{ PropertyInfo?.Bed_Rooms }}</div> Beds
                                </li>
                                <li *ngIf="PropertyInfo?.Bath_Rooms > 0">
                                    <div class="hd_txt">{{ PropertyInfo?.Bath_Rooms }}</div> Baths
                                </li>
                                <li>
                                    <div class="hd_txt">{{ PropertyInfo?.Property_Measure }}</div>
                                </li>
                            </ul>
                        </div>


                        <div class="box_br mt-3 pad15L">
                            <div class="hd_txt2">Property Features</div>
                            <div class="row card-body">
                                <div class="propertycoln">
                                    <strong class="w-100 propsname">Budget</strong>
                                    <strong class="propertyBasicInfo">
                                        <img src='assets/images/icons/budget_icon.png' /> {{ PropertyInfo?.Budget }}
                                    </strong>
                                </div>
                                <div class="propertycoln">
                                    <strong class="w-100 propsname">Measure</strong>
                                    <strong class="propertyBasicInfo">
                                        <img src='assets/images/icons/try-square _icon.png' /> {{
                                        PropertyInfo?.Property_Measure }}
                                    </strong>
                                </div>
                                <div class="propertycoln">
                                    <strong class="w-100 propsname">Posted on</strong>
                                    <strong class="propertyBasicInfo">
                                        <img src='assets/images/icons/time_icon.png' />{{
                                        PropertyInfo?.Date_of_Posting }}
                                    </strong>
                                </div>

                                <ng-container *ngIf="isSale">

                                    <ng-container
                                        *ngIf="PropertyInfo?.IsOpenLand == 0 && PropertyInfo?.IsOpenPlot == 0 && ![17, 20, 21, 22, 23].includes(+PropertyInfo?.PropertySubTypeID)">
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Bedrooms</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/BedIcon.svg" /> {{
                                                PropertyInfo.Bed_Rooms }} BD
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Bathrooms</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/BathIcon.svg" /> {{
                                                PropertyInfo.Bath_Rooms }} BA
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Lift</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/Elevator.svg" /> {{ PropertyInfo.Lift
                                                == 0 ? 'No ' : PropertyInfo.Lift }} Lift
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Parking</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/Parking.svg" /> {{
                                                PropertyInfo.Car_Parking == 0 ? 'No ' : PropertyInfo.Car_Parking }}
                                                Car P
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">How Old?</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/property.svg" /> {{
                                                PropertyInfo.Property_Age === 0 ? 'New' : PropertyInfo.Property_Age
                                                + ' M Old' }}
                                            </span>
                                        </div>

                                    </ng-container>

                                    <ng-container
                                        *ngIf="PropertyInfo?.IsOpenLand == 1 || PropertyInfo?.IsOpenPlot == 1">
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Road Size</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/road_icon.png" /> {{
                                                PropertyInfo?.Road_Size }} SFT
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Road Type</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/road_type_icon.png" /> {{
                                                PropertyInfo?.Road_Type }}
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Property Facing </strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/facing_icon.png" /> {{
                                                PropertyInfo?.Property_Facing }}
                                            </span>
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="PropertyInfo?.IsOpenLand == 1 || PropertyInfo?.IsOpenPlot == 1">
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Dist NHW</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/two-way-street_icon.png"
                                                    style="height: 20px; width: 20px; margin-right: 5px;" /> {{
                                                PropertyInfo?.Distance_NHW }} KM
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <span class="propertyBasicInfo">
                                                <strong class="w-100 propsname">Dist ORR</strong>
                                                <img src="assets/images/icons/ramp_icon.png"
                                                    style="height: 20px; width: 20px; margin-right: 5px;" /> {{
                                                PropertyInfo?.Distance_ORR }} KM
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Permission</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/authority_icon.png"
                                                    style="height: 20px; width: 20px; margin-right: 5px;" />
                                                {{ PropertyInfo?.Layout_Authority }}
                                            </span>
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="PropertyInfo?.IsOpenLand == 1 && PropertyInfo?.IsOpenPlot == 0">
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Water</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/water_facility_icon.png"
                                                    style="height: 20px; width: 20px; margin-right: 5px;" />
                                                {{ PropertyInfo?.Water_Facility == 0 ? 'No ' : 'Yes' }}
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Fencing</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/Fencing_icon.png"
                                                    style="height: 20px; width: 20px; margin-right: 5px;" />
                                                {{ PropertyInfo?.Fencing == 0 ? 'No ' : 'Yes' }}
                                            </span>
                                        </div>


                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Electricity</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/electricity_icon.png"
                                                    style="height: 20px; width: 20px; margin-right: 5px;" />
                                                {{ PropertyInfo?.Electricity == 0 ? 'No ' : 'Yes' }}
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Soil Type</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/soil_icon.png"
                                                    style="height: 25px; width: 21px; margin-right: 5px;" />
                                                {{ PropertyInfo?.Socil_Type }}
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Crop</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/harvest _icon.png"
                                                    style="height: 20px; width: 20px; margin-right: 5px;" />
                                                {{ PropertyInfo?.Crop_Plantation }}
                                            </span>
                                        </div>
                                    </ng-container>

                                </ng-container>

                                <ng-container *ngIf="!isSale">

                                    <ng-container
                                        *ngIf="PropertyInfo?.IsOpenLand == 0 && PropertyInfo?.IsOpenPlot == 0 && ![17, 20, 21, 22, 23].includes(+PropertyInfo?.PropertySubTypeID)">
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Bedrooms</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/BedIcon.svg" />
                                                {{ PropertyInfo?.Bed_Rooms }} BD
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Bathrooms</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/BathIcon.svg" />
                                                {{ PropertyInfo?.Bath_Rooms }} BA
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Lift</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/Elevator.svg" />
                                                {{ PropertyInfo?.Lift == 0 ? 'No ' : PropertyInfo?.Lift }}
                                                Lift
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Parking</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/Parking.svg" />
                                                {{ PropertyInfo?.Car_Parking == 0 ? 'No ' :
                                                PropertyInfo?.Car_Parking }} Car P
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">How Old?</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/property.svg" />
                                                {{ PropertyInfo?.Property_Age === 0 ? 'New' :
                                                PropertyInfo?.Property_Age + ' M
                                                Old' }}
                                            </span>
                                        </div>
                                    </ng-container>


                                    <ng-container
                                        *ngIf="PropertyInfo?.IsOpenLand == 1 || PropertyInfo?.IsOpenPlot == 1">
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Road Size</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/road_icon.png" />
                                                {{
                                                PropertyInfo?.Road_Size }} SFT
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Road Type</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/road_type_icon.png" />
                                                {{
                                                PropertyInfo?.Road_Type }}
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Property Facing </strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/facing_icon.png" />
                                                {{
                                                PropertyInfo?.Property_Facing }}
                                            </span>
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="PropertyInfo?.IsOpenLand == 1 || PropertyInfo?.IsOpenPlot == 1">

                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Dist NHW</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/two-way-street_icon.png" />
                                                {{
                                                PropertyInfo?.Distance_NHW }} KM
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <span class="propertyBasicInfo">
                                                <strong class="w-100 propsname">Dist ORR</strong>
                                                <img src="assets/images/icons/ramp_icon.png" />
                                                {{
                                                PropertyInfo?.Distance_ORR }} KM
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Permission</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/authority_icon.png" />
                                                {{
                                                PropertyInfo?.Layout_Authority }}
                                            </span>
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="PropertyInfo?.IsOpenLand == 1 && PropertyInfo?.IsOpenPlot == 0">
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Water</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/water_facility_icon.png" />
                                                {{
                                                PropertyInfo?.Water_Facility == 0 ? 'No ' : 'Yes' }}
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Fencing</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/Fencing_icon.png" />
                                                {{
                                                PropertyInfo?.Fencing == 0 ? 'No ' : 'Yes' }}
                                            </span>
                                        </div>
                                        <div class="col-4  propertycoln">
                                            <strong class="w-100 propsname">Electricity</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/electricity_icon.png" />
                                                {{
                                                PropertyInfo?.Electricity == 0 ? 'No ' : 'Yes' }}
                                            </span>
                                        </div>
                                        <div class="col-4 pt-3 propertycoln">
                                            <strong class="w-100 propsname">Soil Type</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/soil_icon.png" />
                                                {{
                                                PropertyInfo?.Socil_Type }}
                                            </span>
                                        </div>
                                        <div class="propertycoln">
                                            <strong class="w-100 propsname">Crop</strong>
                                            <span class="propertyBasicInfo">
                                                <img src="assets/images/icons/harvest _icon.png" />
                                                {{
                                                PropertyInfo?.Crop_Plantation }}
                                            </span>
                                        </div>
                                    </ng-container>

                                </ng-container>

                            </div>
                        </div>
                    </div>

                    <div class="box_br mt-3 amenities_div" *ngIf="PropertyInfo?.Amenities?.length > 0">
                        <div class="hd_txt2">Amenities</div>
                        <div class="amenities-info leftli amenities">
                            <ul>
                                <li *ngFor="let aminity of PropertyInfo.Amenities">
                                    <img [src]="aminity?.icon"
                                        onerror="this.src='assets/icons/amenities/amenities_ic.png';" />
                                    <div>{{ aminity?.name }}</div>
                                </li>
                            </ul>
                        </div>
                    </div>



                    <div class="box_br mt-3">
                        <div class="hd_txt2">Description</div>
                        <div class="para-100" [innerHtml]="PropertyInfo?.ShortDescription"></div>
                    </div>

                    <div class="box_br mt-3">
                        <div class="hd_txt2">Property Location</div>
                        <div class="mapViewWrapper" *ngIf="PropertyInfo != null" style="height: calc(100% - 50px);">
                            <div class="innerMapView" id="map" style="height: 250px;"></div>
                        </div>
                        <!-- <img src="assets/images/property/Property_location_map.png" class="w-100"> -->
                    </div>

                    <div class="box_br mt-3">
                        <div class="hd_txt2">Live Street View</div>
                        <div class="mapViewWrapper" *ngIf="PropertyInfo != null" style="height: calc(100% - 50px);">
                            <div class="innerStreetView" id="street-view" style="height: 300px;">
                            </div>
                        </div>
                        <!-- <div class="dash_br"><img src="assets/images/property/Live_Street_View_pic.png" class="w-100"></div> -->
                    </div>
                    <!--
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="box_br mt-3 pad0A">
                                <div align="center" class="locality_txt">Locality</div>
                                <div class="clear"></div>
                                <div class="row mrg0A">     
                                    <div class="col-md-4 pad10A" align="center">
                                    <div class="pad10A" align="center">
                                        <div><span class="hd_txt">4.4</span><span class="area_txt">/ 5</span></div>
                                        <div><img src="assets/images/property/star_rating.png"></div>
                                        <div>Average Rating</div>
                                        <div class="area_txt">(338 Total Reviews)</div>
                                        <div class="rating_cls">
                                            <table width="90%" border="0" cellspacing="0" cellpadding="0" align="center">
                                                <tr>
                                                    <td>
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar" aria-valuenow="70"
                                                                aria-valuemin="0" aria-valuemax="100" style="width:70%">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td width="40" align="center">
                                                        5 <img src="assets/images/property/star_ic.png" align="absmiddle" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar" aria-valuenow="70"
                                                                aria-valuemin="0" aria-valuemax="100" style="width:50%">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td width="40" align="center">
                                                        4 <img src="assets/images/property/star_ic.png" align="absmiddle" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar" aria-valuenow="70"
                                                                aria-valuemin="0" aria-valuemax="100" style="width:30%">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td width="40" align="center">
                                                        3 <img src="assets/images/property/star_ic.png" align="absmiddle" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar" aria-valuenow="70"
                                                                aria-valuemin="0" aria-valuemax="100" style="width:20%">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td width="40" align="center">
                                                        2 <img src="assets/images/property/star_ic.png" align="absmiddle" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar" aria-valuenow="70"
            
                                                                aria-valuemin="0" aria-valuemax="100" style="width:0%">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td width="40" align="center">
                                                        1 <img src="assets/images/property/star_ic.png" align="absmiddle" />
                                                    </td>
                                                </tr>
                                            </table>
                        
                        
                                        </div>
                        
                                        <div class="txt_13_gray">See how ratings are calculated</div>
                                    </div></div>
        
        
                                    <div class="col-md-8 rating_left_br pad10A">
                                        <div class="txt_15_b">Ratings by Features</div>
                                        <ul class="leftli rating_features pt-2">
                                            <li>
                                                <div class="features_icon_bg"><img src="assets/images/property/connectivity_icon.png"></div>
                                                <div class="txt_15_b">Connectivity</div>
                                                <div class="txt_13_gray">4.5 Out of 5</div>
                                            </li>
                                            <li>
                                                <div class="features_icon_bg"><img src="assets/images/property/connectivity_icon.png"></div>
                                                <div class="txt_15_b">Lifestyle</div>
                                                <div class="txt_13_gray">4.5 Out of 5</div>
                                            </li>
                                            <li>
                                                <div class="features_icon_bg"><img src="assets/images/property/connectivity_icon.png"></div>
                                                <div class="txt_15_b">Safety</div>
                                                <div class="txt_13_gray">4.5 Out of 5</div>
                                            </li>
                                            <li>
                                                <div class="features_icon_bg"><img src="assets/images/property/connectivity_icon.png"></div>
                                                <div class="txt_15_b">Environment</div>
                                                <div class="txt_13_gray">4.5 Out of 5</div>
                                            </li>
                                        </ul>
                                        <div class="clear mb-2"></div>
                                        <div class="txt_15_b">Popular Mentions</div>
                                        <div class="rating_cls">
                                            <table width="100%" border="0" cellspacing="0" cellpadding="0" align="center">
                                                <tr>
                                                    <td>
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar" aria-valuenow="70"
                                                                aria-valuemin="0" aria-valuemax="100" style="width:100%">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="txt_13_gray" width="160">&nbsp; 100% Positive Mentions</td>
                                                </tr>
                                            </table>
                                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                                <tr>
                                                    <td width="70" valign="top" class="txt13">
                                                        <img src="assets/images/property/like_icon.png" /> Likes
                                                    </td>
                                                    <td>
                                                        <ul class="leftli">
                                                            <li>
                                                                <div class="popular_txt">Good Public Transport(224)</div>
                                                            </li>
                                                            <li>
                                                                <div class="popular_txt">Easy Cab/Auto Availability(198)</div>
                                                            </li>
                                                            <li>
                                                                <div class="popular_txt">Safe at Night (121)</div>
                                                            </li>
                                                            <li>
                                                                <div class="popular_txt">Well-maintained Roads(142)</div>
                                                            </li>
                                                            <li>
                                                                <div class="popular_txt">Good Schools are nearby (100)</div>
                                                            </li>
                                                            <li>
                                                                <div class="popular_txt">Markets at a walkable distance(121)</div>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                                <tr>
                                                    <td width="70" class="txt13">
                                                        <img src="assets/images/property/dislike_icon.png" /> Dislikes
                                                    </td>
                                                    <td>
                                                        <ul class="leftli">
                                                            <li>
                                                                <div class="popular_txt">No Metro Connectivity(43)</div>
                                                            </li>
                                                            <li>
                                                                <div class="popular_txt">Frequent Parking Issues(21)</div>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </table>
                        
                                        </div>
                                    </div>
                        
                                </div>
                            </div>
                    
                        </div>
                    
                    </div>
                -->
                </div>


                <div class="col-md-4">
                    <div class="contact_div">
                        <div class="contact_txt">Contact</div>
                        <div class="contact_user"><img src="assets/images/property/Contact_pic.png" /></div>
                        <div class="hd_txt" align="center">{{ PropertyInfo?.Posted_by }}</div>
                        <div class="txt_13_gray" align="center">
                            <img src="assets/images/property/contact_star.png" /> 5.0 (24 Review)
                        </div>
                        <div class="txt_15_b" align="center">{{ PropertyInfo?.Posted_Type }}</div>
                        <div align="center" class="area_txt">
                            <img src="assets/images/property/location.png" align="absmiddle" /> LB Nagar, Hyderabad.
                            T.S
                        </div>
                        <div class="contact_user_div">
                            <div class="agent_bg">
                                <table border="0" cellspacing="0" cellpadding="0">
                                    <tr>
                                        <td>Contact&nbsp;
                                            <button (click)="doContactAgent('Call', PropertyInfo)" type="button"
                                                class="btn btn-primary mx-auto" style="padding: 0px;">
                                                <img src="assets/images/property/contact_Icon_1.png"
                                                    style="width: 32px; height: 32px;">
                                            </button>
                                        </td>
                                        <td width="30" align="center">
                                            <div class="brlrb"></div>
                                        </td>
                                        <td>SMS&nbsp;
                                            <button (click)="doContactAgent('Message', PropertyInfo)" type="button p-0"
                                                class="btn btn-primary mx-auto" style="padding: 0px;">
                                                <img src="assets/images/property/SMS_Icon.png"
                                                    style="width: 32px; height: 32px;">
                                            </button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="performance_div">
                        <div class="performance_txt">Property Performance</div>
                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><strong>Metric</strong></td>
                                <td><strong>Value <div> This Week/Total</div></strong></td>
                            </tr>
                            <tr class="over">
                                <td>No of Visitis</td>
                                <td>{{ Performance?.Views }}</td>
                            </tr>
                            <tr>
                                <td>No of Clicks</td>
                                <td>{{ Performance?.Clicks }}</td>
                            </tr>
                            <tr class="over">
                                <td>No of Calls</td>
                                <td>{{ Performance?.Calls }}</td>
                            </tr>
                            <tr>
                                <td>No of SMS</td>
                                <td>{{ Performance?.SMS }}</td>
                            </tr>
                        </table>

                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <div class="chat_div">
                                <div class="chat_txt">AI ChatBot
                                    <div align="center" class="txt_13_gray">Query anything related to this Property
                                    </div>
                                </div>
                                <div class="chat_display"></div>
                                <div class="chat_bottom"><input type="text" placeholder="Type here" />
                                    <img src="assets/images/property/send_icon.png" />
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>